import React, { useState, useEffect } from 'react';
import { NormalPeoplePicker } from '@fluentui/react';
import { API } from '../../API/API';
import { debounce } from 'lodash';
import { MessageConst } from '../../const/MessageConst';

const FieldEmployee = (props) => {

    const [selectedRow, setSelectedRow] = useState(new Array(0));

    const onFilterChagned = async (filterText, currentPersonas) => {
        let tData = [];
        if (filterText) {
            await API.get("/api/humanresource/employee/get_employee_dropdown?search=" + filterText).then(response => {
                if (response.status === 200 && response.data?.rettype === 0) {
                    if (response.data?.retdata?.length > 0) {
                        tData = response.data.retdata;
                    }
                }
            });
        }

        tData?.map(r => {
            r.secondaryText = r.secondarytext ? r.secondarytext : '--'
        });
        setSelectedRow(tData?.filter(r => r.key == props.defaultValue));
        return tData;
    };

    useEffect(() => {
        if (props.defaultText) {
            onFilterChagned(props.defaultText, null);
        }
    }, [props?.defaultValue]);

    const onEmptyInputFocus = async () => {
        let tData = [];
        await API.get("/api/humanresource/employee/get_employee_dropdown?lfr=true").then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                if (response.data.retdata?.length > 0) {
                    tData = response.data.retdata;
                }
            }
        });

        tData?.map(r => {
            r.secondaryText = r.secondarytext ? r.secondarytext : '--'
        });

        return tData;
    }

    const onSelectEmp = (p_value) => {
        setSelectedRow(p_value);
        if (p_value?.length > 0) {
            props.onChanged(p_value[0].key, p_value[0].secondaryText, props.keyfield, p_value[0].email);
        }
    }

    return (
        <div>
            <div style={{ fontWeight: 600, fontSize: 14 }}>{props.title}</div>
            <div style={{ marginTop: 6 }}>
                <NormalPeoplePicker
                    onResolveSuggestions={onFilterChagned}
                    onEmptyInputFocus={onEmptyInputFocus}
                    resolveDelay={1000}
                    itemLimit={1}
                    onChange={onSelectEmp}
                    pickerSuggestionsProps={{
                        noResultsFoundText: 'Харуулах мэдээлэлгүй байна',
                    }}
                    selectedItems={selectedRow}
                    inputProps={{
                        placeholder: props.title
                    }}
                />
                {(props.required && !props.defaultValue && props.checkreq) ? (
                    <div style={{ color: 'rgb(164, 38, 44)', fontSize: 12, fontWeight: 400, paddingTop: 5 }}>
                        {props.title + MessageConst.fieldRequired}
                    </div>
                ) : null}
            </div>
        </div>
    );
}

export default FieldEmployee;